module.exports = __webpack_public_path__ + "img/close2.f647d4e5.svg";